import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from "axios";

export default function ProtectedRoute({ children, requireBilling = true }) {
  const token = localStorage.getItem("token");
  const location = useLocation();
  const [isCheckingBilling, setIsCheckingBilling] = useState(requireBilling);
  const [needsBilling, setNeedsBilling] = useState(false);
  const [authFailed, setAuthFailed] = useState(false);

  useEffect(() => {
    if (!requireBilling || !token) {
      setIsCheckingBilling(false);
      return;
    }

    const checkBillingStatus = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/billing/subscription`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // If no subscription or not active, redirect to billing
        if (!res.data.has_subscription || !res.data.is_active) {
          setNeedsBilling(true);
        }
      } catch (err) {
        console.error("Error checking billing status:", err);
        if (err.response?.status === 401) {
          localStorage.removeItem("token");
          setAuthFailed(true);
        } else if (err.response?.status === 403) {
          setNeedsBilling(true);
        }
      } finally {
        setIsCheckingBilling(false);
      }
    };

    checkBillingStatus();
  }, [token, requireBilling]);

  if (!token) {
    // Redirect to login if not authenticated
    return <Navigate to="/refer/login" replace />;
  }

  if (authFailed) {
    return <Navigate to="/refer/login" replace />;
  }

  if (isCheckingBilling) {
    // Show loading state while checking billing status
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (needsBilling && location.pathname !== "/refer/billing") {
    // Redirect to billing if subscription required but not active
    return <Navigate to="/refer/billing" replace />;
  }

  return children;
}
